module.exports = __webpack_public_path__ + "static/Jaki-CRM-dla-malej-firmy-529f8eb68cb4702af401503aaf4ea4c2.png";